<template>
  <v-select
    id="axis-select"
    v-model="filter.selo"
    item-text="nome"
    item-value="selo"
    :items="selos"
    :label="name || 'Selos'"
    placeholder="Selecione.."
    :return-object="true"
    multiple
    @change="$emit('change', filter.selo)"
  >
    <div
      style="display: flex; padding: 0 16px; cursor: pointer"
      slot="prepend-item"
      ripple
      @click="toggle"
    >
      <div style="margin-right: 32px">
        <v-icon :color="filter.selo.length > 0 ? 'indigo darken-4' : ''">{{
          icon
        }}</v-icon>
      </div>
      <div>Todos</div>
    </div>
    <v-divider slot="prepend-item" class="mt-2" />

    <template v-slot:selection="{ item, index }">
      <span v-if="index < maxDisplay"
        >{{ item
        }}{{
          index === 0 && filter.selo && filter.selo.length > 1 ? "," : ""
        }}
        &nbsp;</span
      >
      <span v-if="index === maxDisplay" class="grey--text caption"
        >(+{{ filter.selo.length - maxDisplay }} selos)</span
      >
    </template>

    <template slot="no-data"> Nenhum Selo retornado </template>
  </v-select>
</template>

<script>
export default {
  name: "ComboboxSelo",
  props: ["filter", "name"],
  methods: {
    toggle() {
      this.$nextTick(() => {
        if (this.likesAll) {
          this.filter.selo = [];
        } else {
          this.filter.selo = this.selos.slice();
        }
      });
    },
  },
  computed: {
    likesAll() {
      return this.filter.selo.length === this.selos.length;
    },
    likesSome() {
      return this.filter.selo.length > 0 && !this.selos;
    },
    icon() {
      if (this.likesAll) return "mdi-close-box";
      if (this.likesSome) return "mdi-minus-box";
      return "mdi-checkbox-blank-outline";
    },
  },
  data() {
    return {
      maxDisplay: 1,
      selos: ["Sem selo", "Bronze", "Prata", "Ouro"],
    };
  },
};
</script>
